/* tslint:disable */
/* eslint-disable */
export enum WorkOpenAbsencesScopeEnum {
  Team = 'team',
  All = 'all'
}
